import Vue from 'vue';
import Router from 'vue-router';
import BasicInfo from '@/views/BasicInfo.vue';
import DocumentInfo from '@/views/DocumentInfo.vue';
import NotFoundComponent from '@/views/NotFoundComponent.vue';
import DataValidation from '@/views/DataValidation.vue';
import AdditionalInformation from '@/views/AdditionalInformation.vue';
import Thanks from '@/views/Thanks.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'basic-info',
      component: BasicInfo,
    },
    {
      path: '/document',
      name: 'document-info',
      component: DocumentInfo,
    },
    {
      path: '/data',
      name: 'data-validation',
      component: DataValidation,
    },
    {
      path: '/additional',
      name: 'additional-information',
      component: AdditionalInformation,
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: Thanks,
    },
    {
      path: '*',
      name: '404',
      component: NotFoundComponent,
    },
  ],
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(from);
  if (!hasQueryParams(to) && hasQueryParams(from) && to.name === 'basic-info') {
    next({ name: to.name, query: from.query });
  } else {
    next();
  }
});

export default router;
